import React, { useEffect, useRef } from "react";
import { pick } from "@/lib/languages";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

const COPY = {
  en: { title: "Verify your identity", hint: "Enter your authenticator code or a recovery code.",
    code: "Verification code", verify: "Verify and sign in", back: "Back to sign in" },
  fr: { title: "Vérifiez votre identité", hint: "Saisissez le code de votre application ou un code de récupération.",
    code: "Code de vérification", verify: "Vérifier et se connecter", back: "Retour à la connexion" },
  es: { title: "Verifica tu identidad", hint: "Introduce el código de tu aplicación de autenticación o un código de recuperación.",
    code: "Código de verificación", verify: "Verificar e iniciar sesión", back: "Volver al inicio de sesión" },
  pt: { title: "Verifique sua identidade", hint: "Digite o código do seu aplicativo autenticador ou um código de recuperação.",
    code: "Código de verificação", verify: "Verificar e entrar", back: "Voltar ao login" },
  ar: { title: "تحقق من هويتك", hint: "أدخل رمز تطبيق المصادقة أو رمز استرداد.",
    code: "رمز التحقق", verify: "تحقق وسجل الدخول", back: "العودة إلى تسجيل الدخول" },
  zh: { title: "验证您的身份", hint: "请输入身份验证器代码或恢复代码。",
    code: "验证码", verify: "验证并登录", back: "返回登录" },
};

export default function MfaChallengeForm({ lang, code, onCodeChange, onSubmit, onCancel, busy, idPrefix = "mfa" }) {
  const copy = pick(COPY, lang);
  const input = useRef(null);
  useEffect(() => { input.current?.focus(); }, []);
  return <form onSubmit={onSubmit} className="space-y-4" aria-label={copy.title}>
    <h2 className="font-semibold text-touki-black">{copy.title}</h2>
    <p id={`${idPrefix}-hint`} className="text-sm text-touki-muted">{copy.hint}</p>
    <div>
      <Label htmlFor={`${idPrefix}-code`}>{copy.code}</Label>
      <Input ref={input} id={`${idPrefix}-code`} autoComplete="one-time-code" required
        aria-describedby={`${idPrefix}-hint`} value={code} onChange={(event) => onCodeChange(event.target.value)}
        className="mt-1 h-11" />
    </div>
    <Button type="submit" disabled={busy} className="w-full h-11 bg-touki-red text-white">
      {busy ? "…" : copy.verify}
    </Button>
    <Button type="button" variant="outline" disabled={busy} className="w-full h-11" onClick={onCancel}>
      {copy.back}
    </Button>
  </form>;
}
